import React, { useMemo, useState } from "react";

export default function ConnectAmazonButton({ className = "" }) {
  const [err, setErr] = useState("");

  // Read query params once
  const { spid, corr } = useMemo(() => {
    try {
      const p = new URLSearchParams(window.location.search);
      return {
        spid: p.get("spid") || "",
        corr: p.get("corr") || "",
      };
    } catch (e) {
      setErr("Invalid URL");
      return { spid: "", corr: "" };
    }
  }, []);

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied!");
    } catch {
      setErr("Copy failed. Please copy manually.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 600 }}>
        <div
          className={className}
          style={{
            width: "100%",
            padding: 24,
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
            background: "#fff",
          }}
        >
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Warning</h1>

          <p style={{ fontSize: 16, color: "#555", marginTop: 12 }}>
            Please check if the refresh token is stored securely on the server.
            The redirection failed, but it might still have been saved in the
            database.
          </p>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>YOUR SPID</label>
            <div
              style={{
                marginTop: 6,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <code
                style={{
                  padding: "8px 10px",
                  background: "#f5f5f5",
                  borderRadius: 6,
                  fontSize: 14,
                  wordBreak: "break-all",
                  flex: 1,
                }}
              >
                {spid || "(missing)"}
              </code>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <label style={{ fontSize: 12, color: "#666" }}>REF (corr)</label>
            <div
              style={{
                marginTop: 6,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <code
                style={{
                  padding: "8px 10px",
                  background: "#f5f5f5",
                  borderRadius: 6,
                  fontSize: 14,
                  wordBreak: "break-all",
                  flex: 1,
                }}
              >
                {corr || "(missing)"}
              </code>
            </div>
          </div>

          {err && (
            <div
              role="alert"
              style={{
                color: "crimson",
                marginTop: 12,
                background: "#fff1f2",
                border: "1px solid #fecdd3",
                padding: 10,
                borderRadius: 8,
              }}
            >
              {err}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
